export default "__VITE_ASSET__lRY2luAq__"